import { writeCCPACookie } from "@/common/functions";

import AppInput from "@/components/AppInput/AppInput.vue";
import VueRecaptcha from "vue-recaptcha";

import format from "date-format";
import axios from "axios";

import { mapGetters } from "vuex";

// import AuthService from "@/services/AuthService";

const privacyApi = axios.create({
    baseURL: process.env.PRIVACY_API
});

export default {
    components: {
        AppInput,
        VueRecaptcha
    },
    props: {
        agreementCheckboxes: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: {
                name: "",
                email: "",
                phone: "",
                street_address: "",
                state: "",
                zip_code: ""
            },
            isValidForm: false,
            isSubmitForm: false,
            sitekey: "6Ld3LdgUAAAAAKEwzMGVyej5CD1H2m6LtiapOoZ9",
            isVerifiedCaptcha: false
        };
    },
    computed: {
        ...mapGetters("Login", ["user"]),
        isDisabled() {
            return !(this.isValidForm && this.isVerifiedCaptcha && this.isOneAgreement);
        },
        btnText() {
            return this.isSubmitForm
                ? this.$t("ccpaPageFormSubmittedButtonText")
                : this.$t("ccpaPageSubmitButtonText");
        },
        btnAriaLabel() {
            return this.isSubmitForm
                ? this.$t("ccpaPageSubmitButtonAriaLabel")
                : this.$t("ccpaPageSubmitButtonAriaLabel");
        },
        btnTitle() {
            return this.isSubmitForm
                ? this.$t("ccpaPageSubmitButtonTitleAttribute")
                : this.$t("ccpaPageSubmitButtonTitleAttribute");
        },
        isOneAgreement() {
            return Object.values(this.agreementCheckboxes).some(item => item);
        }
    },
    methods: {
        verifyCaptcha(token) {
            this.isVerifiedCaptcha = !!token;
            this.validateForm();
        },
        onCaptchaExpired() {
            this.isVerifiedCaptcha = false;
            this.$refs.recaptcha.reset();
        },
        validateForm() {
            const result = Object.keys(this.form).map(item => {
                return this.form[item] !== "";
            });

            this.isValidForm = result.every(item => item);
        },
        getPrivacyString() {
            const toDelete = this.agreementCheckboxes.req_to_delete;
            const toOptOut = this.agreementCheckboxes.req_to_opt_out;
            const privacy = [1, "Y", "N", "Y"];

            if (toOptOut || toDelete) privacy[2] = "Y";

            return privacy.join("");
        },
        submit() {
            const staticData = {
                product: "YD",
                date: format("dd-MM-yyyy", new Date()),
                privacy_string: this.getPrivacyString(),
                device_id: "",
                ...this.agreementCheckboxes
            };
            const payload = { ...staticData, ...this.form };

            privacyApi
                .post(
                    "/ccpaOptOut",
                    { ...payload },
                    { headers: { "Content-Type": "application/json" } }
                )
                .then(() => (this.isSubmitForm = true))
                .catch(() => (this.isSubmitForm = false));

            writeCCPACookie(this.getPrivacyString());

            // If the user is logged in, store user CCPA string as a custom claim.
            // if (this.user && this.user.loggedIn) {
            //     AuthService.setUsprivacy({ usprivacy: staticData.privacy_string })
            //         .then(() => {
            //             // eslint-disable-next-line no-console
            //             console.log(`CCPA claim saved ${staticData.privacy_string}`);
            //         })
            //         .catch(error => {
            //             // eslint-disable-next-line no-console
            //             console.error(`Error saving CCPA claim`, error);
            //         });
            // }

            this.isVerifiedCaptcha = false;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/CCPAForm/CCPAForm.js